<div class="mt-4 p-3">
  <div class="row">
    <div class="col-12 col-xl-auto mb-0 pr-0">
      <div class="d-flex align-items-center button-group enable" style="border-radius: 8px;height:60px">
        <button style="border-radius: 8px; height:52px; font-weight: bold;" [ngClass]="nowTabPage == '1' ? 'btn active' : 'btn'" (click)="nowTabPage = '1'; ShowDatePickered(); deviceLocalDataList()">device_local_data</button>
        <span *ngIf="!(nowTabPage == '1' || nowTabPage == '2')" class="divider"></span>
        <button style="border-radius: 8px; height:52px; font-weight: bold;" [ngClass]="nowTabPage == '2' ? 'btn active' : 'btn'" (click)="nowTabPage = '2'; ShowDatePickered(); apiLogDataList()">api_log</button>
        <span *ngIf="!(nowTabPage == '2' || nowTabPage == '3')" class="divider"></span>
        <button style="border-radius: 8px; height:52px; font-weight: bold;" [ngClass]="nowTabPage == '3' ? 'btn active' : 'btn'" (click)="nowTabPage = '3'; ShowDatePickered(); apiLogDataList()">api_log_tmp</button>
        <span *ngIf="!(nowTabPage == '3' || nowTabPage == '4')" class="divider"></span>
        <button style="border-radius: 8px; height:52px; font-weight: bold;" [ngClass]="nowTabPage == '4' ? 'btn active' : 'btn'" (click)="nowTabPage = '4'; ShowDatePickered(); apiLogDataList()">api_log_live</button>
      </div>
    </div>
    <div class="col-12 col-xl pl-1 mt-sm-1 mt-xl-0">
      <div class="d-flex justify-content-start align-items-center px-3 ml-2 button-group w-100" style="border-radius: 8px; height:60px; gap: 10px;">
        <span class="font-weight-bold text-nowrap">🔎 搜尋條件:</span>
    
        <div class="d-flex align-items-center" style="gap: 10px;">
          <div *ngIf="nowTabPage == '1'" class="flex-grow-1 flex-shrink-1">
            <app-date class="" [type]="true" [timeset]="timeSet" [time]="logDate" (rangeSelected)="deviceLocalDataHandleRangeSelected($event)" (showDatePickered)="deviceLocalDataShowDatePickered()"></app-date>
          </div>
          <input *ngIf="nowTabPage == '1'" type="text" class="form-control flex-grow-1 flex-shrink-1" (change)="deviceLocalDataList()" [(ngModel)]="searchUserID" placeholder="搜尋用戶..." style="max-width: 200px;">
          <select *ngIf="nowTabPage == '1'" class="form-control flex-grow-1 flex-shrink-1" style="width: 180px;" [(ngModel)]="deviceLocalSelected" (change)="deviceLocalDataList()">
              <option *ngFor="let item of selectOptions" [ngValue]="item.id" >{{item.name}}</option>
          </select>
          <select *ngIf="nowTabPage == '1'" class="form-control flex-grow-1 flex-shrink-1" style="width: 120px;" [(ngModel)]="deviceLocalDataPageObj.count" (change)="deviceLocalDataList()">
            <option *ngFor="let count of rowCountOptions" [ngValue]="count">{{ count }} 行</option>
          </select>
  
          <div *ngIf="nowTabPage != '1'" class="flex-grow-1 flex-shrink-1">
            <app-date class="" [type]="true" [timeset]="timeSet" [time]="logDate" (rangeSelected)="apiLogDataHandleRangeSelected($event)" (showDatePickered)="dapiLogDataShowDatePickered()"></app-date>
          </div>
          <input *ngIf="nowTabPage != '1'" type="text" class="form-control flex-grow-1 flex-shrink-1" (change)="apiLogDataList()" [(ngModel)]="searchUserID" placeholder="搜尋用戶..." style="max-width: 200px;">
          <select *ngIf="nowTabPage != '1'" class="form-control flex-grow-1 flex-shrink-1" style="width: 180px;" [(ngModel)]="logSelected" (change)="apiLogDataList()">
            <option *ngFor="let item of api_logList" [ngValue]="item.path" >{{item.path}}</option>
          </select>
          <select *ngIf="nowTabPage != '1'" class="form-control flex-grow-1 flex-shrink-1" style="width: 120px;" [(ngModel)]="api_logDataPageObj.count" (change)="apiLogDataList()">
            <option *ngFor="let count of rowCountOptions" [ngValue]="count">{{ count }} 行</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="nowTabPage == '1'">
    <div class="d-flex justify-content-start align-items-start p-1 " style="overflow: visible !important; align-items: flex-start;">  
        
        <!-- 左邊 Table -->
        <div class="col bg-white p-1 rounded">
            <app-table-v2-ot 
                [paddingInput]="0"  
                [data]="deviceLocalData" 
                [tcontent]="deviceLocalDataTcontent" 
                [type]="2" 
                (viewDetail)="deviceHandleJsonData($event)">
            </app-table-v2-ot>

            <app-pagnation (callback)="deviceLocalDataCallBack($event)" [data]="deviceLocalDataPageObjStr"></app-pagnation>
 
        </div>

        <!-- 右邊 JSON 檢視 -->
        <div class="col border rounded rounded-lg bg-white ml-2 pt-2" style="position: sticky; top: 10px;">
            <app-json-viewer [jsonData]="selectedJsonData[0] != null ? selectedJsonData[0] : selectedJsonData"></app-json-viewer>
        </div>

    </div>
  </div>

  <div *ngIf="nowTabPage == '2'">
    <div class="d-flex justify-content-start align-items-start p-1 " style="overflow: visible !important; align-items: flex-start;">  
        
      <!-- 左邊 Table -->
      <div class="col bg-white p-1 rounded">
          <app-table-v2-ot 
              [paddingInput]="0"  
              [data]="api_logData" 
              [tcontent]="api_logTcontent" 
              [type]="2" 
              (viewDetail)="apiLogHandleJsonData($event)">
          </app-table-v2-ot>

          <app-pagnation (callback)="apiLogDataCallBack($event)" [data]="api_logDataPageObjStr"></app-pagnation>
      </div>

      <!-- 右邊 JSON 檢視 -->
      <div class="position-sticky col border rounded rounded-lg bg-white ml-2 pt-2" style="position: sticky; top: 10px;">
        <app-json-viewer [jsonData]="selectedJsonData[0] != null ? selectedJsonData[0] : selectedJsonData"></app-json-viewer>
      </div>
    </div>
  </div>

  <div *ngIf="nowTabPage == '3'">
    <div class="d-flex justify-content-start align-items-start p-1 " style="overflow: visible !important; align-items: flex-start;">  
        
      <!-- 左邊 Table -->
      <div class="col bg-white p-1 rounded ">
          <app-table-v2-ot 
              [paddingInput]="0"  
              [data]="api_logData" 
              [tcontent]="api_logTcontent" 
              [type]="2" 
              (viewDetail)="apiLogHandleJsonData($event)">
          </app-table-v2-ot>

          <app-pagnation (callback)="apiLogDataCallBack($event)" [data]="api_logDataPageObjStr"></app-pagnation>

      </div>

      <!-- 右邊 JSON 檢視 -->
      <div class="position-sticky col border rounded rounded-lg bg-white ml-2 pt-2" style="position: sticky; top: 10px;">
        <app-json-viewer [jsonData]="selectedJsonData[0] != null ? selectedJsonData[0] : selectedJsonData"></app-json-viewer>
      </div>
    </div>
  </div>

  <div *ngIf="nowTabPage == '4'">
    <div class="d-flex justify-content-start align-items-start p-1 " style="overflow: visible !important; align-items: flex-start;">  
        
      <!-- 左邊 Table -->
      <div class="col bg-white p-1 rounded">
          <app-table-v2-ot 
              [paddingInput]="0"  
              [data]="api_logData" 
              [tcontent]="api_logTcontent" 
              [type]="2" 
              (viewDetail)="apiLogHandleJsonData($event)">
          </app-table-v2-ot>

          <app-pagnation (callback)="apiLogDataCallBack($event)" [data]="api_logDataPageObjStr"></app-pagnation>

      </div>

      <!-- 右邊 JSON 檢視 -->
      <div class="position-sticky col border rounded rounded-lg bg-white ml-2 pt-2" style="position: sticky; top: 10px;">
        <app-json-viewer [jsonData]="selectedJsonData[0] != null ? selectedJsonData[0] : selectedJsonData"></app-json-viewer>
      </div>
    </div>
  </div>

</div>
<app-spinner [loading]="loading"></app-spinner>